import { VerticalListComponentProps } from '../verticallistcomponent';
import { UIComponentHandler, UIDataModel, UIComponentState, UIComponentImpl } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { PaginationVerticalListViewImpl } from './paginationverticallistview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { PaginationVerticalListCSSStyleImpl } from './paginationverticallistcss';
import { BaseContext } from '../../../../utils/basecontext';


export interface PaginationVerticalListComponentProps<T> extends VerticalListComponentProps<T>
{
    onLoadMore(startIndex: number, offset: number): void;
}

export class PaginationVerticalListComponent<T> extends UIComponentImpl<PaginationVerticalListComponentProps<T>, UIComponentState, UIDataModel> 
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PaginationVerticalListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PaginationVerticalListCSSStyleImpl(applicationContext);
    }

    updatePaginationCount()
    {
        (this.getView() as PaginationVerticalListViewImpl<T>).updatePaginationCount();
    }

    resetPaginationCount()
    {
        (this.getView() as PaginationVerticalListViewImpl<T>).resetPaginationCount();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationverticallistcomponent.tsx